module.exports = __webpack_public_path__ + "img/TIMES.c734d873.svg";